import AfEditor from '@/components/Aform/AfEditor';
import './index.css';

export default {
  name: 'Aform',
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class="a-form">
        <AfEditor inline global={false} {...{ attrs }} />
      </div>
    );
  }
}